module.exports = __webpack_public_path__ + "static/kuhne-sm-b6e87110a0f381e938be84da9bd62a54.jpg";